<template>
    <kgr-form-scaffold
        :pending="pending"
        :pending-delete="pendingRemove"
        :with-delete-button="isDeletable"
        edit-mode
        :with-primary-buttons="isEditable"
        @primaryBtnClicked="updateMemberLogin"
        @deleteBtnClicked="removeMemberLogin"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-member-login-data-provider
            :member-id="memberId"
            :callback="onMemberLoginLoaded"
        >
            <div class="animated fadeIn">
                <kgr-edit-login-form
                    :login="memberLogin"
                    :error="error"
                />
            </div>
        </kgr-member-login-data-provider>
    </kgr-form-scaffold>
</template>

<script>
import EditLoginForm from '../../components/login/EditLoginForm';
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold';
import MemberLoginDataProvider from '../../components/data-provider/MemberLoginDataProvider';
import MemberRepository from '../../js/repository/MemberRepository';

export default {
    components: {
        'kgr-member-login-data-provider': MemberLoginDataProvider,
        'kgr-edit-login-form': EditLoginForm,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
        isDeletable: {
            type: Boolean,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            pendingRemove: false,
            error: new Error(),
            memberLogin: new Error(),
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onMemberLoginLoaded(loadedMemberLogin) {
            this.memberLogin = loadedMemberLogin;
        },
        updateMemberLogin() {
            this.pending = true;

            MemberRepository.updateLoginData(this.memberId, this.memberLogin)
                .then(() => {
                    this.error = new Error();
                    this.$notify.success('saveChanges.success');
                    this.pending = false;
                })
                .catch(error => {
                    this.error = error;
                    this.$notify.error('saveChanges.error');
                    this.pending = false;
                });
        },
        removeMemberLogin() {
            showConfirm(this.$t('confirm'), this.$t('Soll der Login für die E-Mail Adresse {username} wirklich deaktiviert werden?', {'username': this.memberLogin.username}), () => {
                this.pendingRemove = true;
                MemberRepository.removeLoginData(this.memberId)
                    .then(() => {
                        this.error = new Error();
                        this.$notify.success('Login erfolgreich deaktiviert', {}, { saveInSession: true });
                        this.memberLogin.username = '';
                        this.pendingRemove = false;
                    })
                    .catch(error => {
                        this.pendingRemove = false
                        this.handleError(error);
                    });
            }, 'Ok');
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
